var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.527,
    height: 9.3,
    viewBox: "0 0 13.527 9.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1328.236 -224.107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1337.203 225.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.392,147.9l4.56,2.883V144.9Z",
    transform: "translate(-339.392 -144.896)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1328.236 225.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,144.9v5.888L4.56,147.9Z",
    transform: "translate(0 -144.896)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1328.262 224.107)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.616,80H1.78a.835.835,0,0,0-.82.719L7.7,85.159l6.738-4.439A.835.835,0,0,0,13.616,80Z",
    transform: "translate(-0.96 -80)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1328.264 229.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.189,277.921l-1.2.788a.424.424,0,0,1-.465,0l-1.2-.789-5.308,3.357a.834.834,0,0,0,.818.714H13.679a.834.834,0,0,0,.818-.714Z",
    transform: "translate(-1.024 -277.92)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhite);
export default __webpack_public_path__ + "static/media/Mail-white.061e4c87038662b8e20359e53d750b53.svg";
export { ForwardRef as ReactComponent };